import { systemIds } from '@/shared/utils';
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['mat'], // 为了获取基础路由
    };
};
//bussinessCode 和 各菜单 审批路由 的 映射
export const matToPathNameMap = {
    //采购管理-取消单
    mat1160: ({ businessKey, variables: { orderType, busType } }) => {
        let baseUrl = '';
        //区分菜单 采购合同3 和 采购订单4
        if (orderType === 3) {
            baseUrl = '/buyManage/contract/';
        }
        else if (orderType === 4) {
            baseUrl = '/buyManage/order/';
        }
        let url = '';
        //区分业务 作废 关闭 取消关闭 取消作废
        //busType: 1 | 2 | 3 | 4 //业务类型（1 作废 2 关闭 3 取消关闭 4取消作废）
        if (busType === 1) {
            url = 'cancel';
        }
        else if (busType === 2) {
            url = 'close';
        }
        else if (busType === 3) {
            url = 'removeClose';
        }
        else if (busType === 4) {
            url = 'removeCancel';
        }
        return commonFunc(`${baseUrl}${url}/detail?id=${businessKey}`);
    },
    //采购管理-采购合同
    mat1110: ({ businessKey }) => commonFunc(`/buyManage/contract/detail?id=${businessKey}`),
    //采购管理-采购合同变更
    mat1120: ({ businessKey }) => commonFunc(`/buyManage/contractVary/detail?id=${businessKey}`),
    //采购订单
    mat1130: ({ businessKey }) => commonFunc(`/buyManage/order/detail?id=${businessKey}`),
    //采购订单变更
    mat1140: ({ businessKey }) => commonFunc(`/buyManage/orderVary/detail?id=${businessKey}`),
    // 物资-盘点任务
    mat1910: ({ businessKey }) => commonFunc(`/stock/inventory-tasks/detail?id=${businessKey}`),
    // 物资盘点
    mat1920: ({ businessKey }) => commonFunc(`/stock/material-inventory/detail?id=${businessKey}`),
    // 物资-其它入库
    mat1960: ({ businessKey }) => commonFunc(`/stock/other-in-warehouse/detail?id=${businessKey}`),
    // 物资-其他出库
    mat1950: ({ businessKey }) => commonFunc(`/stock/other-out-warehouse/detail?id=${businessKey}`),
    // 物资处置结算
    mat1370: ({ businessKey }) => commonFunc(`/stock/disposal-settlement/detail?id=${businessKey}`),
    // 废旧物资处置
    mat1350: ({ businessKey }) => commonFunc(`/stock/material-disposal/detail?id=${businessKey}`),
    // 周转材-盘点任务
    mat1380: ({ businessKey }) => commonFunc(`/turnoverMaterial/inventory-tasks/detail?id=${businessKey}`),
    // 周转材-盘点
    mat1390: ({ businessKey }) => commonFunc(`/turnoverMaterial/material-inventory/detail?id=${businessKey}`),
    //  周转材-其他入库
    mat1470: ({ businessKey }) => commonFunc(`/turnoverMaterial/other-in-warehouse/detail?id=${businessKey}`),
    //  周转材-其他出库
    mat1460: ({ businessKey }) => commonFunc(`/turnoverMaterial/other-out-warehouse/detail?id=${businessKey}`),
    // 需求计划
    mat1060: ({ businessKey, variables: { orderType } }) => {
        const objMap = new Map([
            [1, '/buy/total'],
            [2, '/buy/part'],
            [3, '/buy/need'], // 需用计划
        ]);
        const baseUrl = objMap.get(Number(orderType)) || '';
        return commonFunc(`${baseUrl}/detail?id=${businessKey}`);
    },
    // 变更计划
    mat1070: ({ businessKey, variables: { orderType } }) => {
        const objMap = new Map([
            [1, '/buy/totalVary'],
            [2, '/buy/partVary'],
            [3, '/buy/needVary'], // 需用计划
        ]);
        const baseUrl = objMap.get(Number(orderType)) || '';
        return commonFunc(`${baseUrl}/detail?id=${businessKey}`);
    },
    // 材料采购申请
    mat1080: ({ businessKey }) => commonFunc(`/buy/material/detail?id=${businessKey}`),
    // 领料出库 // 物资
    mat1090: ({ businessKey }) => commonFunc(`/stock/mterialsOut/detail?id=${businessKey}`),
    // 领料入库
    mat1100: ({ businessKey }) => commonFunc(`/stock/mterialsIn/detail?id=${businessKey}`),
    // 调拨申请
    mat1310: ({ businessKey }) => commonFunc(`/stock/transferApplication/detail?id=${businessKey}`),
    // 调拨入库
    mat1320: ({ businessKey }) => commonFunc(`/stock/allocation-in/detail?id=${businessKey}`),
    // 调拨出库
    mat1330: ({ businessKey }) => commonFunc(`/stock/allocation-out/detail?id=${businessKey}`),
    // 摊销 // 周转材
    mat1340: ({ businessKey }) => commonFunc(`/turnoverMaterial/selfMaterials/detail?id=${businessKey}`),
    // 进场
    mat1150: ({ businessKey }) => commonFunc(`/turnoverMaterial/leaseIn/detail?id=${businessKey}`),
    // 出场
    mat1360: ({ businessKey }) => commonFunc(`/turnoverMaterial/leaseOut/detail?id=${businessKey}`),
    // 停租
    mat1170: ({ businessKey }) => commonFunc(`/turnoverMaterial/leasePause/detail?id=${businessKey}`),
    //调拨
    mat1180: ({ businessKey }) => commonFunc(`/turnoverMaterial/transferApplication/detail?id=${businessKey}`),
    // 调拨出
    mat1190: ({ businessKey }) => commonFunc(`/turnoverMaterial/allotOut/detail?id=${businessKey}`),
    // 调拨入
    mat1200: ({ businessKey }) => commonFunc(`/turnoverMaterial/allotIn/detail?id=${businessKey}`),
    // 收票 // 收付款
    mat1210: ({ businessKey }) => commonFunc(`/ticketManagement/putInvoice/detail?id=${businessKey}`),
    // 开票
    mat1220: ({ businessKey }) => commonFunc(`/ticketManagement/giveInvoice/detail?id=${businessKey}`),
    // 付款
    mat1230: ({ businessKey }) => commonFunc(`/ticketManagement/payment/detail?id=${businessKey}`),
    // 收款
    mat1240: ({ businessKey }) => commonFunc(`/ticketManagement/proceeds/detail?id=${businessKey}`),
};
